import PropTypes from "prop-types";
import LinkField from "../../shared/v2/LinkField";

const UrlInputWrap = ({ value, onChange, onBlur, onKeyPress }) => (
  <LinkField
    containerClassName="tw-w-full tw-flex-1"
    autoFocus
    hideActions
    value={value}
    onBlur={onBlur}
    onKeyPress={onKeyPress}
    onChange={(e) => onChange(e.target.value)}
  />
);
UrlInputWrap.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func.isRequired,
};
export default UrlInputWrap;
